import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/index.css';

// Ensure jQuery plugins are initialized after React renders
window.addEventListener('load', () => {
  // Initialize WOW animations
  if (typeof WOW !== 'undefined') {
    new WOW().init();
  }
});

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);